<template>
  <div class="view contentBody">
    <div class="title">员工管理</div>
    <div class="flexrow_wrap">
      <div class="org_tree">
        <div class="tree_filter">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText" size="small">
            <el-button slot="append" icon="el-icon-search" @click="filterkeyword" size="small"></el-button>
          </el-input>
        </div>
        <div class="search_result" v-if="!treeflag">
          <p>共有 {{count}}个搜索结果</p>
          <ul class="treelist">
            <li
                    v-for="(item,index) in result"
                    :key="index"
                    @click="handleNode(item)"
            >{{item.name}}
            </li>
          </ul>
        </div>
        <el-tree
                v-if="treeflag"
                class="filter-tree"
                default-expand-all
                :props="props"
                :load="loadNode"
                lazy
                ref="tree"
                @node-click="handleNode"
        >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <div class="tree_title">
                <div class="tree_label">{{ node.label }}</div>
                <div class="tree_oper">
                  <i class="tree_btn el-icon-circle-plus-outline" @click.stop="() => adddep(data)"></i>
                  <i class="tree_btn el-icon-edit-outline" @click.stop="() => editdep(data)"></i>
                  <i
                          class="tree_btn el-icon-remove-outline"
                          v-if="node.level>1"
                          @click.stop="() => deldep(data)"
                  ></i>
                </div>
              </div>
            </span>
        </el-tree>
      </div>
      <div class="flex_content">
        <!--<div class="notice">-->
        <!--<p>商城功能未开启，如需在小程序展示商城，请先在“商城设置”中启用商城功能。</p>-->
        <!--</div>-->
        <div class="manage-title">
          <p class="manage-title-l">{{companyname}}</p>
          <div class="manage-title-r">
            <span class="manage-title-r-word">全部组织架构可见</span>
            <el-switch
                    v-model="switch_structure"
                    active-color="#2AA3F8"
                    inactive-color="#ddd"
                    @change="changeswitch()"
            ></el-switch>
          </div>
        </div>
        <div class="condition">
          <div class="search_wrap">
            <el-form :inline="true" :model="formdata" class="form-inline">
              <el-form-item>
                <el-input v-model="formdata.name" placeholder="请输入姓名搜索" size="small">
                  <el-button slot="append" icon="el-icon-search" @click="search()" size="small"></el-button>
                </el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="other_wrap">
            <el-button type="primary" @click="addemployee" size="small">添加成员</el-button>
          </div>
        </div>
        <p class="appUserName">当前app管理员为：{{app_admin}}</p>
        <div class="table_oper">
          <!--<el-button>批量导入</el-button>-->
          <el-button @click="detelAllBox" size="small">批量删除</el-button>
          <el-button size="small">同步</el-button>
          <!--<el-button @click="exportexcel" size="small">导出</el-button>-->
          <el-button @click="choosedep" size="small">设置app管理员</el-button>
          <i class="iconfont iconbangzhu icondefult ml-10" @click="helpFn"></i>
        </div>
        <div class="table_wrap">
          <el-table
                  :data="tableData"
                  style="width: 100%"
                  @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"
                             :selectable='checkboxT'></el-table-column>
            <el-table-column prop="work_number" label="工号" width="100"></el-table-column>
            <el-table-column label="头像" width="100">
              <template slot-scope="scope">
                <div class="td_img">
                  <img :src="scope.row.pic" alt/>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名" width="100"></el-table-column>
            <el-table-column prop="position" label="职位"></el-table-column>
            <el-table-column label="部门">
              <template slot-scope="scope">
                <span class="diparment">{{scope.row.department}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="手机"></el-table-column>
            <el-table-column prop="role" label="企管角色"></el-table-column>
            <el-table-column prop="is_out" label="是否内部人员">
              <template slot-scope="scope">
                <span>{{scope.row.is_out==1? '是':'否'}}</span>
              </template> 
            </el-table-column>
            <el-table-column label="最后登录时间" width="120">
              <template slot-scope="scope">
                <span>{{scope.row.last_login_time || '无'}}</span>
              </template>              
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <span @click="employeeedit(scope.row.id)" class="action_btn">编辑</span>
                <span @click="employeedetail(scope.row.id)" class="action_btn">查看详情</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="pag_wrap">
            <el-pagination
                    background
                    @current-change="pageIndexChange"
                    :page-size="page.pagesize"
                    :current-page="page.pageindex"
                    layout="total, prev, pager, next"
                    :total="page.total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!--下载-->
    <iframe id="iframe" frameborder=0 name="showHere" scrolling=auto :src="iframeSrc"
            class="iframeBoxLine"></iframe>
    <addOrgDialog
            :visible.sync="addorgdialog"
            v-if="addorgdialog"
            :parentDepartId="parentDepartId"
            :departId="departId"
            :departName="departName"
            @addeditdepsucess="addeditdepsucess"
    ></addOrgDialog>
    <chooseManagerDialog
            :visible.sync="choosedepdialog"
            v-if="choosedepdialog"
            @userDetail="userDetail"
            :typeDialog="typeDialog"
    ></chooseManagerDialog>
  </div>
</template>
<script>
  import api from "@/api.js";
  import {pagination} from "@/util/util.js";
  import addOrgDialog from "@/components/dialog/addOrgDialog.vue";
  import chooseManagerDialog from "@/components/dialog/chooseManagerDialog.vue";

  export default {
    name: "manage",
    components: {
      addOrgDialog,
      chooseManagerDialog,
    },
    data() {
      return {
        typeDialog: 2,
        filterText: "",
        count: "",
        result: [],
        treeflag: true,
        props: {
          label: "name",
          children: "zones",
          isLeaf: "leaf"
        },
        formdata: {
          name: "",
          depart_id: ""
        },
        tableData: [],
        page: {
          pageindex: pagination.pageIndex,
          pagesize: pagination.pageSize,
          total: pagination.total
        },
        parentDepartId: "",
        departId: "",
        departName: "",
        addorgdialog: false,
        switch_structure: false,
        iframeSrc: '',
        choosedepdialog: false,
        companyname: null,
        app_admin: null
      };
    },
    created() {
      this.init();
      this.companyNameFn()
    },
    methods: {
      companyNameFn() {
        this.axios
            .post(api.company_index, {})
            .then(response => {
              if (response.data.code == 0) {
                this.companyname = response.data.info.name
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 关键字查询
      filterkeyword() {
        if (this.filterText == "") {
          this.treeflag = true;
        } else {
          this.formdata.depart_id = "";
          this.treeflag = false;
          let params = {
            name: this.filterText
          };
          this.axios
              .post(api.department_searchs, params)
              .then(response => {
                if (response.data.code == 0) {
                  this.count = response.data.count;
                  this.result = response.data.list || [];
                } else {
                }
              })
              .catch(response => {
              });
        }
      },
      pageIndexChange(pageindex) {
        this.page.pageindex = pageindex;
        this.queryemployee();
      },
      // 懒加载
      async loadNode(node, resolve) {
        if (node.level === 0 || node.level === 1) {
          let res = await this.querydep();
          if (res && res.data.code === 0) {
            if (node.level === 0) {
              return resolve([
                {name: res.data.info.name, id: res.data.info.id}
              ]);
            } else {
              let deplist = res.data.info.list || [];
              return resolve(deplist);
            }
          } else {
            return resolve([]);
          }
        }
        if (node.level > 1) {
          let id = node.data.id;
          let childres = await this.querychilddep(id);
          if (childres && childres.data.code === 0) {
            let childdep = childres.data.list || [];
            return resolve(childdep);
          } else {
            return resolve([]);
          }
        }
      },
      checkboxT(row, rowIndex) {
        if (row.name===this.app_admin) {
          return false;//禁用
        } else {
          return true;//不禁用
        }
      },
      // 查询部门
      querydep() {
        let params = {};
        return this.axios.post(api.department_index, params);
      },
      // 查询子部门
      querychilddep(id) {
        let params = {
          depart_id: id
        };
        return this.axios.post(api.department_getchild, params);
      },
      addeditdepsucess() {
        this.treeflag = false;
        setTimeout(() => {
          this.treeflag = true;
        }, 500);
      },
      handleNode(data) {
        console.log(data);
        this.formdata.depart_id = data.id;
        this.search();
      },
      // 创建部门
      adddep(data) {
        this.parentDepartId = data.id;
        this.departId = "";
        this.departName = "";
        this.addorgdialog = true;
      },
      // 选择部门
      choosedep() {
        this.choosedepdialog = true;
      },
      userDetail(val) {
        this.axios
            .post(api.employee_set_appadmin, {em_id: val.id})
            .then(response => {
              if (response.data.code == 0) {
                this.choosedepdialog = false;
                this.queryemployee()
                this.$confirm('设置成功!', '提示', {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  type: 'success'
                }).then(() => {
                }).catch(() => {
                });
              } else {
                this.$confirm(response.data.msg, '提示', {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  type: 'warning'
                }).then(() => {
                }).catch(() => {
                });
              }
            })
            .catch(response => {
            });
        // this.formdata.depart_name = val.name;
        // this.formdata.depart_id = val.id;

      },
      // 创建部门
      editdep(data) {
        this.parentDepartId = "";
        this.departId = data.id;
        this.departName = data.name;
        this.addorgdialog = true;
      },
      deldep(data) {
        let params = {
          depart_id: data.id
        };
        this.axios
            .post(api.department_delete, params)
            .then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: "删除部门成功",
                  type: "success"
                });
              } 
            })
            .catch(response => {
            });
      },
      // 搜索
      search() {
        this.init();
      },
      //初始化请求
      init() {
        this.page.pageindex = 1;
        this.queryemployee();
      },

      // 查询员工
      queryemployee() {
        let params = {
          page: this.page.pageindex,
          name: this.formdata.name,
          depart_id: this.formdata.depart_id
        };
        this.axios
            .post(api.employee_index, params)
            .then(response => {
              if (response.data.code == 0) {
                this.tableData = response.data.list;
                this.page.total = response.data.all_page;
                let switch_structure = false;
                if (response.data.switch_structure === 1) {
                  switch_structure = true;
                }
                this.switch_structure = switch_structure;
                this.page.total = response.data.all_page;
                this.app_admin = response.data.app_admin
              } else {
                this.page.total = 0;
              }
            })
            .catch(response => {
            });
      },
      // 导出
      exportexcel() {
        // let params = {};
        let self_ = this
        this.$confirm(
            "确认要导出《成员列表信息》数据吗?",
            "数据导出",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              offset: 40
            }).then(() => {
          this.iframeSrc = this.responHost + api.employee_out
          setTimeout(() => {
            self_.iframeSrc = ''
          }, 1000)
        })
            .catch(() => {
              this.iframeSrc = ''
            });
      },
      addemployee() {
        this.$router.push({name: "employeeAdd"});
      },
      employeeedit(id) {
        this.$router.push({name: "employeeEdit", query: {employeeid: id}});
      },
      employeedetail(id) {
        this.$router.push({name: "employeeDetail", query: {employeeid: id}});
      },
      // 批量删除
      detelAllBox() {
        if (this.SelectionVal) {
          let detelId = [];
          let _this = this;
          for (let i in this.SelectionVal) {
            detelId.push(this.SelectionVal[i].id);
          }
          this.axios.post(api.employee_delete, {em_id: detelId}).then(res => {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            _this.init();
          });
        } else {
          this.$message({
            message: '请选择人员进行删除操作',
            center: true,
            type: 'warning'
          });
        }
      },
      // 选项
      handleSelectionChange(val) {
        this.SelectionVal = val;
      },
      handleCurrentChange(pageindex) {
        this.page.pageindex = pageindex;
        this.queryemployee();
      },
      changeswitch() {
        let self_ = this
        // 全部组织架构可见开关(0关闭、1开启)
        if (!this.switch_structure) {
          this.$confirm(
              "关闭后，员工在“造像时代-我-进入我的企业”将只能看到自己所在部门的组织架构，确认关闭?",
              "提示",
              {
                confirmButtonText: "确认关闭",
                cancelButtonText: "取消",
                type: "warning"
              }
          )
              .then(() => {
                self_.axios
                    .post(api.employee_structure, {switch_structure: 0})
                    .then(response => {
                      if (response.data.code == 0) {
                        self_.switch_structure = false;
                      } else {
                      }
                    })
                    .catch(response => {
                    });
              })
              .catch(() => {
                this.switch_structure = true;
              });
        } else {
          // 全部组织架构可见开关(0关闭、1开启)
          this.$confirm(
              "开启后，员工在“云知APP-我-进入我的企业”将能看到企业所有组织架构，确认开启？",
              "提示",
              {
                confirmButtonText: "确认开启",
                cancelButtonText: "取消",
                type: "warning"
              }
          )
              .then(() => {
                this.axios
                    .post(api.employee_structure, {switch_structure: 1})
                    .then(response => {
                      if (response.data.code == 0) {
                        self_.switch_structure = true;
                      } else {
                      }
                    })
                    .catch(response => {
                    });
              })
              .catch(() => {
                this.switch_structure = false;
              });

        }
      },
      helpFn() {
        this.$alert('有员工申请加入企业，会发送短信给管理员，提示去app审核。', '小贴士', {
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
          confirmButtonText: '知道了'
        });
      }
    }
  };
</script>
<style>
  .search_result li {
    white-space: nowrap;
    overflow: hidden;
    font-size: 13px;
  }
</style>
